<template>
<!-- 填写合同记录 -->
    <div>
        <el-form
              ref="formPayment"

              :rules="formPaymentRules"
              :model="form"
              label-width="140px"
            >
             <el-form-item label="合同名称" prop="name" >
                  <el-row :gutter="24">
                     <el-col :span="18">
                       <div style="display:flex">
                            <el-input v-model="form.name" disabled ></el-input>
                            <el-button type="primary" size="small" @click="addConstract" v-show="operateStatus">选择合同</el-button>
                        </div>

                     </el-col>

                  </el-row>
                </el-form-item>
              <el-form-item label="合同编号" prop="code" >
                 <el-row :gutter="24">
                   <el-col :span="18">
                     <el-input v-model="form.code" disabled></el-input>
                   </el-col>
                 </el-row>

                </el-form-item>
                 <el-form-item label="供应商名称" prop="partnerName" >
                    <el-row :gutter="24">
                   <el-col :span="18">
                     <el-input  v-model="form.partnerName"  disabled  ></el-input>
                   </el-col>
                 </el-row>

                </el-form-item>
              <el-form-item :label="`结算金额`" prop="payAmount">
                <el-row :gutter="24">
                   <el-col :span="18">
                       <moneyInput v-model="form.payAmount" placeholder="请输入结算金额" :disabled="!operateStatus" template="append" style="width: 100%"  />
                   </el-col>
                 </el-row>

              </el-form-item>
              <el-form-item :label="`结算日期`" prop="payTime">
                <el-row :gutter="24">
                   <el-col :span="18">
                      <el-date-picker clearable style="width:100%" v-model="form.payTime" type="date" placeholder="选择日期" :disabled="!operateStatus" value-format="yyyy-MM-dd hh:mm:ss">
                      </el-date-picker>
                   </el-col>
                 </el-row>

              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-row :gutter="24">
                   <el-col :span="18">
                      <el-input
                      clearable
                      v-model="form.remark" :disabled="!operateStatus" maxlength="200"
                        show-word-limit></el-input>
                   </el-col>
                 </el-row>

              </el-form-item>
              <el-form-item label="附件">
                <VUpload :fileList.sync="form.attachList" action="/api/v4ward/oss/customEndpoint/put-file" :disabled="!operateStatus" />
              </el-form-item>
              <el-form-item style="text-align:right" v-if="operateStatus">
                <el-button type="primary" @click="onSubmit" style="margin-right: 20px"
                  >确定</el-button
                >
                <el-button @click="closeRecord">取消</el-button>
              </el-form-item>
            </el-form>
            <el-dialog
                title="选择合同"
                :visible.sync="dialogVisible"
                width="70%"
                append-to-body="true"
                :before-close="handleClose"
                :close-on-click-modal="false">
             <!-- :projectId="form.projectId" -->
             <choiceContract :projectId='projectId' @close='dialogClose'  @getConstract="getConstract"></choiceContract>
             </el-dialog>
              <!-- <choiceContract @getConstracr="getConstract"></choiceContract> -->
    </div>
</template>

<script>

import VUpload from '@/views/components/v-upload.vue';
import choiceContract from '@/components/choiceContract/choiceContract';
export default {
  components: { VUpload,choiceContract},
  props:{
      form:{
          default:{
               projectId:'',
                name:'',
                code:'',
                partnerName:'',
                id:'',
                payTime:'',
                attachList:[],
                remark:''

          },
      },
      projectId:'',
      operateStatus:{
        default:true,
        type:Boolean
      }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入小数点前9位后2位小数的金额'));
      }
    };
    return {
      dialogVisible:false,
      dialogConstract:{},
      formPaymentRules: {
        name: [{ required: true, message: '请选择合同', trigger: 'change' }],
        payAmount: [{ required: true, validator: validatePass, trigger: 'blur' }],
        payTime: [{ required: true, message: '请选择时间', trigger: 'blur' }],
      },
    };
  },
  created(){
    console.log('1111',this.projectId)
  },
  methods:{
    closeRecord(){
      this.$emit('close')
    },
    dialogClose(){
      this.dialogVisible = false
    },
      getConstract(val){
        this.dialogVisible = false
        //   this.form = val
        // this.form.name = val.name
        this.$set(this.form,'name',val.name)
        this.form.code = val.code
        this.form.partnerName = val.partnerName
        this.form.contractId = val.id
      },
      //打开选择合同对话框
      addConstract(){
          this.dialogVisible = true
      },
      //确认合同
      onSubmit(){
         this.$refs['formPayment'].validate((valid) => {
          if (valid) {
          //  this.form.payTime = this.dayjs(this.form.payTime).format('YYYY-MM-DD')
            this.$emit("submitInfo",this.form)
          } else {
            console.log('error submit!!');
            return false;
          }
        });

      }
  }
};
</script>

<style>
</style>
